export enum MatchSignalAttribute {
  name = 'name',
  dob = 'dob',
  ssn = 'ssn',
  address = 'address',
  email = 'email',
  phone = 'phone',
  document = 'document',
  businessName = 'businessName',
  businessTIN = 'businessTin',
  businessAddress = 'businessAddress',
  businessBeneficialOwners = 'businessBeneficialOwners',
  businessPhoneNumber = 'businessPhoneNumber',
}

export default MatchSignalAttribute;
